import { create } from 'zustand';

/** Entra session; tokens live in MSAL's cache. */
export type AuthSession = {
  username: string;
  name: string;
  oid: string;
};

type AuthState = {
  session: AuthSession | null;
  setSession: (session: AuthSession | null) => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  session: null,
  setSession: (session) => set({ session }),
}));
